import React, { useEffect, useState } from "react";

// Components
import { Modal, Form, Spin, notification } from "antd";
import OrderInfoForm from "./OrderInfoForm";

// lib
import Orderlib from "../../lib/fulfillment/order";
import Organization from "../../lib/organization";

// Hooks
import { useHistory } from "react-router-dom";
import { useOrderCreate } from "../../hooks/api/fulfillment/orders";

// Interfaces
import { Fulfillment } from "@secondcloset/types";
type Order = Fulfillment.Order;

interface Props {
  visible: boolean;
  organizationID: string;
  setVisible: (visible: boolean) => unknown;
}

export const CreateOrderDevTool: React.FC<Props> = ({
  visible,
  organizationID,
  setVisible,
}) => {
  const [orderForm] = Form.useForm();
  // const [shipmentForm] = Form.useForm();

  const isIkea = Organization.isIkeaOrgID(organizationID);

  const { orderCreateDetails, createOrder } = useOrderCreate();
  const history = useHistory();

  const [orderFormloading, setOrderFormloading] = useState(false);

  const loading = orderFormloading || orderCreateDetails.loading;

  useEffect(() => {
    const error = orderCreateDetails.error;
    if (!error) return;
    notification.error({
      message: "Error",
      description: error,
    });
  }, [orderCreateDetails.error]);

  useEffect(() => {
    const order = orderCreateDetails.data;
    if (order && !orderCreateDetails.loading) {
      history.push(`/fulfillment/orders/${order.id}`);
      setVisible(false);
      orderForm.resetFields();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderCreateDetails.data, orderCreateDetails.loading]);

  const onCreateOrderClicked = async () => {
    const platform = isIkea ? "centiro" : "manual";
    const itemList = [{ id: orderForm.getFieldValue("product"), quantity: 2 }];
    const body = Orderlib.getCreateOrderBody({
      itemList,
      customerInformation: { id: orderForm.getFieldValue("customer") },
      addressInformation: { id: orderForm.getFieldValue("address") },
      external_order_number: orderForm.getFieldValue("externalOrderNumber"),
      external_platform_version: orderForm.getFieldValue("externalPlatformVersion"),
      internal_notes: "",
      fulfilled_from: orderForm.getFieldValue("fullFilledFrom"),
      insurance_value: 0,
      platform,
    });
    (body.orders as any).organization_id = organizationID;

    await createOrder(body);
  };

  return (
    <Modal visible={visible} onCancel={() => setVisible(false)} onOk={() => onCreateOrderClicked()}>
      <Spin spinning={loading}>
        <OrderInfoForm
          form={orderForm}
          isVisible={visible}
          isIkea={isIkea}
          organizationID={organizationID}
          setIsLoading={(loading) => setOrderFormloading(loading)}
        />
      </Spin>
    </Modal>
  );
};
